import { useEffect, useRef } from 'react';

import { createAlert } from '../services/alert-service';
import { logout } from '../globals-service';

const UserListeners = ({ eventEmitter, applyStoreAction, currentUserId }) => {
    const currentUserIdRef = useRef(currentUserId);

    useEffect(() => {
        currentUserIdRef.current = currentUserId;
    }, [currentUserId]);

    const listen = () => {
        eventEmitter.on('user_online', payload => {
            applyStoreAction({
                type: 'USER_UPDATE_ONLINE_STATUS_SOCKET',
                payload: {
                    userId: payload.user_id,
                    online: true
                }
            });
        });

        eventEmitter.on('user_offline', payload => {
            applyStoreAction({
                type: 'USER_UPDATE_ONLINE_STATUS_SOCKET',
                payload: {
                    userId: payload.user_id,
                    online: false
                }
            });
        });

        eventEmitter.on('user_updated', user => {
            applyStoreAction({
                type: 'USER_UPDATE_SOCKET',
                payload: {
                    userId: user.id,
                    user
                }
            });
        });

        eventEmitter.on('role_changed', user => {
            applyStoreAction({
                type: 'USER_UPDATE_SOCKET',
                payload: {
                    userId: user.member_id,
                    user: {
                        role: user.new_role
                    }
                }
            });
        });

        eventEmitter.on('member_removed', payload => {
            if (payload.project_id) {
                applyStoreAction({
                    type: 'PROJECT_USER_REMOVE_SOCKET',
                    payload: {
                        userId: payload.member_id,
                        projectId: payload.project_id
                    }
                });
            } else if (currentUserIdRef.current === payload.member_id) {
                createAlert('default', 'You have been removed from the current team.');

                logout();
            } else {
                applyStoreAction({
                    type: 'TEAM_USER_REMOVE_SOCKET',
                    payload: {
                        userId: payload.member_id
                    }
                });
            }
        });

        eventEmitter.on('member_left', payload => {
            applyStoreAction({
                type: 'TEAM_USER_REMOVE_SOCKET',
                payload: {
                    userId: payload.member_id
                }
            });
        });
    }

    useEffect(listen, []);

    return null;
}

export default UserListeners;
